import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { API_BASE_URL } from "../api";
import "./css/dsgvo.css";

function Impressum() {
    const [legal, setLegal] = useState(null);

    useEffect(() => {
        document.title = "Impressum | James Schreiber Portfolio";
    }, []);

    useEffect(() => {
        async function loadLegal() {
            try {
                const response = await fetch(`${API_BASE_URL}/api/legal`);
                const data = await response.json();
                setLegal(data);
            } catch (error) {
                console.error("Fehler beim Abrufen des Impressums:", error);
            }
        }

        loadLegal();
    }, []);

    const owner = legal?.owner;
    const imprint = legal?.pages?.imprint;

    if (imprint?.visible === false) {
        return <Navigate to="/" replace />;
    }

    return (
        <React.Fragment>
            <div className="feat-dsgvo">
                <section className="datenschutz">
                    <h1>Impressum</h1>
                    <p>{imprint?.extraInfo || "Die Impressumsdaten konnten nicht geladen werden."}</p>

                    <h4>Angaben zum Anbieter</h4>
                    <p>
                        {owner?.name}<br />
                        {owner?.street}<br />
                        {owner?.zip} {owner?.city}<br />
                        {owner?.country}
                    </p>

                    <h4>Kontakt</h4>
                    <p>
                        E-Mail: <a href={`mailto:${owner?.email}`}>{owner?.email}</a><br />
                        Telefon: <a href={`tel:${owner?.phone}`}>{owner?.phone}</a>
                    </p>

                    <h4>Verantwortlich für den Inhalt</h4>
                    <p>{owner?.responsiblePerson || owner?.name}</p>

                    {owner?.vatId && (
                        <>
                            <h4>Umsatzsteuer-ID</h4>
                            <p>{owner.vatId}</p>
                        </>
                    )}

                    <h4>Streitbeilegung</h4>
                    <p>{imprint?.disputeResolution}</p>
                </section>
            </div>

            <footer className="footer">
                <div className="footer-container">
                    <div className="footer-right">
                        <Link to="/">Home</Link>
                    </div>

                    <div className="footer-center">
                        © {new Date().getFullYear()} {owner?.website || "James-Schreiber.de"}
                    </div>

                    <div className="footer-right">
                        <Link to="/datenschutz">Datenschutz</Link>
                    </div>
                </div>
            </footer>
        </React.Fragment>
    );
}

export default Impressum;
